import { Component } from '@angular/core';
import { FooterComponent } from '../../footer/footer.component';

@Component({
  selector: 'app-quotation-generation',
  standalone: true,
  imports: [FooterComponent],
  templateUrl: './quotation-generation.component.html',
  styleUrl: './quotation-generation.component.scss'
})
export class QuotationGenerationComponent {

}
